import { useEffect } from 'react';
// 绑定键盘事件
function useKeydown(onKeyDown, options, listenerFlag) {
  useEffect(() => {
    document.addEventListener('keydown', onKeyDown, listenerFlag);
    return () => {
      document.removeEventListener('keydown', onKeyDown, listenerFlag);
    };
  }, [options]);
}

export default useKeydown;
